import * as React from 'react';
import withStyles from 'react-jss';
import {
  withGoogleMap,
  withScriptjs,
  GoogleMap,
  Marker,
  Polyline,
  InfoWindow,
} from 'react-google-maps';
import { MAP } from 'react-google-maps/lib/constants';
import { VTMapRouteStyle } from './VTMapRouteConstant';
import { useGenericState } from 'src/Library/UseGenericState';
import { StylesProps } from 'src/Library/Types';
const BlueCircleIcon = require('src/assets/images/BlueCircle.svg');
const AnchorIcon = require('src/assets/images/Anchor.svg');
const FlagIcon = require('src/assets/images/Flag.svg');
const VesselShipIcon = require('src/assets/images/VesselShip.svg');
const ZoomOutMapIcon = require('src/assets/images/ZoomOutMap.svg');
const ZoomInMapIcon = require('src/assets/images/ZoomInMap.svg');
import { connect } from 'react-redux';
import { NAVBAR_HEIGHT } from 'src/globals';
import { tokens } from 'src/design-system';
import ContainerDetailsTrackingList from '../ContainerDetailsTrackingList';
import { Icon } from 'antd';
import moment from 'moment';
import { isValidNumber } from 'src/Library/Helper';

declare let google: any;

const styles = () => ({
  portName: {
    color: tokens.colors.textSecondary,
    fontWeight: tokens.fontWeight.semibold,
    fontSize: tokens.fontSize.small,
  },
  timelines: {
    fontSize: tokens.fontSize.caption,
    fontWeight: tokens.fontWeight.regular,
    color: tokens.colors.textSecondary,
    marginTop: tokens.spacing.xs,
    padding: `0 ${tokens.spacing.xs}px ${tokens.spacing.xs}px ${tokens.spacing.xs}px`,
  },
  zoomOutButton: {
    position: 'absolute',
    zIndex: 1000,
    backgroundColor: 'rgba(0, 0, 0, 0.40)',
    padding: '3px',
    top: '22px',
    right: '-60px',
  },
  zoomInButton: {
    position: 'absolute',
    zIndex: 1000,
    backgroundColor: 'rgba(0, 0, 0, 0.40)',
    padding: '3px',
    top: `${NAVBAR_HEIGHT + 16}px`,
    right: '16px',
  },
  containerTrackingList: {
    position: 'absolute !important',
    zIndex: 500,
    padding: '3px !important',
    top: `${NAVBAR_HEIGHT + 22}px !important`,
    left: '22px !important',
    width: '394px !important',
  },
})

interface MapVesselRouteProps extends StylesProps<ReturnType<typeof styles>> {
  zoom: number;
  center: { lat: number, lng: number };
  status: string;
  mapRoute: any; //{ latitude: number, longitude: number, flagS3Link: string, code: string, name: string }[]; CHANGE THIS!!
  markerPosition: { lat: number, lng: number };
  timelines: { etd?: string, eta?: string, atd?: string, ata?: string };
  toggleMapZoom: (
    value?: boolean,
    mapProps?: { center: { lat: number, lng: number }, zoom: number, status: string },
  ) => void;
  isZoomed: boolean;
  containerDetailProps: any;
}

interface StateProps {
  markers: {
    key: number,
    position: { lat: number, lng: number },
    icon?: string
    name?: string,
    isVisibleOnlyOnHover?: boolean,
    flagS3Link?: string,
    code?: string,
  }[];
  originToCurrentLocation: { lat: number, lng: number }[];
  currentLocationToDestination: { lat: number, lng: number }[];
  collapseDetails: boolean;
  selectedTransshipmentMarker?: number | null;
}

const MapVesselRoute = (props: MapVesselRouteProps) => {
  
  const {
    zoom,
    status,
    center,
    mapRoute,
    markerPosition,
    classes,
    timelines,
    toggleMapZoom,
    isZoomed,
    containerDetailProps,
  } = props;
  const [selectedMarkerKey, setSelectedMarkerKey] = React.useState(null); 
  const [state, setState] = useGenericState<StateProps>({
    markers: [],
    originToCurrentLocation: [],
    currentLocationToDestination: [],
    collapseDetails: true,
  });

  const {
    markers,
    originToCurrentLocation,
    currentLocationToDestination,
    collapseDetails,
    selectedTransshipmentMarker,
  } = state;

  React.useEffect(() => {
    getMapRoutes();

    const timeoutId = setTimeout(() => {
      handleInfoWindowStyle();
    }, 200);

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  React.useEffect(() => {
    handleInfoWindowStyle();
  }, [selectedTransshipmentMarker])

  const handleInfoWindowStyle = () : void => {
    const crossIconElement : any = document.getElementsByClassName('gm-ui-hover-effect');
    for (let i = 0; i < crossIconElement.length; i++) {
      const element : any = crossIconElement[i];
      element.style.display = 'none';
    }

    const infoElementInner : any = document.getElementsByClassName('gm-style-iw gm-style-iw-c');
    for (let i = 0; i < infoElementInner.length; i++) {
      const element : any = infoElementInner[i];
      element.style.padding = '0';
    }

    const infoElementOuter : any = document.getElementsByClassName('gm-style-iw-d');
    for (let i = 0; i < infoElementOuter.length; i++) {
      const element : any = infoElementOuter[i];
      element.style.padding = '0';
      element.style.overflow = 'hidden';
    }
  };

  const locationToFlag = {
    AT_ORIGIN: BlueCircleIcon,
    TRANSSHIPMENT: AnchorIcon,
    REACHED_DESTINATION_POD: FlagIcon,
    CURRENT_LOCATION: VesselShipIcon,
  }

  const refObj: any = {};

  const handleMapRef = (ref) => {
    if (!ref) return;
    refObj.map = ref;
    refObj.mapObject = ref.context[MAP];
  };

  type MarkerLocation = keyof typeof locationToFlag;
  type MarkerSize = readonly [number,number];

  const DEFAULT_SIZE = 30;

  const createCustomMarkerIcon = (
    location: MarkerLocation,
    size?: MarkerSize,
  ) => {
    const width = size?.[0] ?? DEFAULT_SIZE;
    const height = size?.[1] ?? DEFAULT_SIZE;

    return {
      url: locationToFlag[location],
      scaledSize: new google.maps.Size(width, height),
    };
  };

  const findClosestPosition = (wayPoints) => {
    if (!markerPosition) return;

    let minDistance = Number.MAX_VALUE;
    let closestPosition = null;

    wayPoints?.forEach(item => {
      const distance = Math.sqrt(
        Math.pow(item.lat - markerPosition.lat, 2) + Math.pow(item.lng - markerPosition.lng, 2)
      );

      if (distance < minDistance) {
        minDistance = distance;
        closestPosition = item;
      }
    });

    return closestPosition;
  }

  const renderMarkupWithTooltip = (marker, selectedMarkerKey, setSelectedMarkerKey) => {
    const { key, position, icon } = marker;
  
    const handleMarkerClick = () => {
      // Toggle the visibility of the InfoWindow for this marker
      setSelectedMarkerKey(selectedMarkerKey === key ? null : key); // Close if the same marker is clicked
    };
  
    return (
      <Marker
        key={key}
        position={position}
        icon={icon && icon()}
        onClick={handleMarkerClick} // handle click event
      >
        {marker.name && (marker.key === selectedMarkerKey) && (
          <InfoWindow
            position={position}
            zIndex={marker.isVisibleOnlyOnHover ? 1000 : 1}
            options={{headerDisabled: true}}
          >
            {renderTooltip(marker)}
          </InfoWindow>
        )}
      </Marker>
    );
  };
  // const renderTimelines = (timeline) => {
  //   const formats = { atd: 'ATD', etd: 'ETD', ata: 'ATA', eta: 'ETA' };
  //   const key = Object.keys(formats).find(key => timeline?.[key]);
  //   return key ? `${formats[key]}: ${moment(timeline[key]).format('DD MMM YYYY')}` : '';
  // }

  const renderTooltip = (marker) => {
    const { flagS3Link, name, code } = marker;

    return (
      <div style={{ padding: '4px' }}>
        <div style={{ padding: '0 4px 0 4px' }}>
          <img src={flagS3Link} style={{ paddingRight: '2px' }} />
          <span className={classes.portName}>{name}</span>
        </div>
      </div>
    )
  }

  const getMarkers = () => {
    return markers?.map((marker) => renderMarkupWithTooltip(marker, selectedMarkerKey, setSelectedMarkerKey));
  }
  const haversine = (lat1, lon1, lat2, lon2) => {
    // Radius of the Earth in kilometers
    const R = 6371.0;
  
    // Convert latitude and longitude from degrees to radians
    const [radLat1, radLon1, radLat2, radLon2] = [lat1, lon1, lat2, lon2].map((val) =>
      (val * Math.PI) / 180
    );
  
    // Calculate the differences
    const dLat = radLat2 - radLat1;
    const dLon = radLon2 - radLon1;
  
    // Haversine formula
    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(radLat1) * Math.cos(radLat2) * Math.sin(dLon / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  
    // Calculate the distance
    const distance = R * c;
  
    return distance;
  }

  const getMapRoutes = () => {
    let markers: {
      key: number,
      position: { lat: number, lng: number },
      icon?: any,
      name?: string,
      isVisibleOnlyOnHover?: boolean,
      flagS3Link?: string,
    }[] = [];
    let waypointsLatLng: { lat: number, lng: number }[] = [];
    let positionArray: {
      location: [number, number],
      flagS3Link?: string,
      code?: string,
      name: string,
    }[] = [];
    let currentPinIdx: number = 0
    
    mapRoute?.portMarkers?.forEach(item => {
      positionArray.push({
        location: [item?.location[0], item?.location[1]],
        name: item?.name,
        
      });
    });

    let idx = 0
    mapRoute?.portMarkers?.forEach(item => {
        markers.push(
          {
            key: idx,
            position: {
              lat: item?.location[0], 
              lng: item?.location[1]
            },
            name: item?.name,
            icon: () => createCustomMarkerIcon(item?.type, [25, 25]),
            flagS3Link: item?.flagS3Link,
          }
        );
        idx = idx + 1
    });
    mapRoute?.vesselPathArrs?.forEach(latLng => {
      waypointsLatLng.push({
        lat: latLng[0],
        lng: latLng[1]
      });
    });

    currentPinIdx =  Math.min(mapRoute?.currentPinIdx || Infinity, waypointsLatLng.length -1)

    if (mapRoute?.currentPinIdx && mapRoute?.currentPinIdx < mapRoute?.vesselPathArrs?.length) {
      markers.push(
        {
          key: idx + 1,
          position: {
            lat: waypointsLatLng[currentPinIdx]?.lat,
            lng: waypointsLatLng[currentPinIdx]?.lng,
          },
          icon: () => createCustomMarkerIcon('CURRENT_LOCATION', [25, 25])
        }
      )
    }
    
    let originToCurrentLocation : { lat: number; lng: number; }[] = waypointsLatLng;
    let currentLocationToDestination : { lat: number; lng: number; }[] = [];

    originToCurrentLocation = waypointsLatLng.slice(0, currentPinIdx);
    currentLocationToDestination = waypointsLatLng.slice(currentPinIdx);

    setState({
      markers,
      originToCurrentLocation,
      currentLocationToDestination,
    });
  }

  const renderZoomedOutButton = () => {
    return (
      <div className={classes.zoomOutButton} onClick={() => toggleMapZoom(true)}>
        <img
          src={ZoomOutMapIcon}
          style={{ width: '24px', height: '24px', cursor: 'pointer' }}
        />
      </div>
    )
  }

  const renderZoomedInButton = () => {
    return (
      <div className={classes.zoomInButton} onClick={() => toggleMapZoom(false)}>
        <img
          src={ZoomInMapIcon}
          style={{ width: '24px', height: '24px', cursor: 'pointer' }}
        />
      </div>
    );
  }

  const renderContainerTrackingList = () => {
    const {
      getFilteredContainers,
      selectedSubContainer,
      container,
      classes,
      noTrackingFound,
      shipmentType,
      renderTrackingView,
      duration,
      isHBL,
      containerDetails,
    } = containerDetailProps;
    return (
      <div
        style={{
          position: 'absolute',
          zIndex: 500,
          top: `${NAVBAR_HEIGHT + 22}px`,
          left: '22px',
          width: '394px',
          backgroundColor: tokens.colors.bgWhite,
          border: `1px solid ${tokens.colors.border}`,
        }}
      >
        {!collapseDetails && <div style={{ height: '550px', overflowY: 'scroll', padding: '12px 6px', }}>
          <ContainerDetailsTrackingList
            getFilteredContainers={getFilteredContainers}
            selectedSubContainer={selectedSubContainer}
            container={container}
            classes={classes}
            noTrackingFound={noTrackingFound}
            shipmentType={shipmentType}
            renderTrackingView={renderTrackingView}
            duration={duration}
            isHBL={isHBL}
            containerDetails={containerDetails}
          />
        </div>}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            color: tokens.colors.textTertiary,
            fontSize: tokens.fontSize.small,
            cursor: 'pointer',
            borderBottom: !collapseDetails ? 'none' : `1px solid ${tokens.colors.border}`,
            borderTop: collapseDetails ? 'none' : `1px solid ${tokens.colors.border}`,
            padding: '12px 14px',
          }}
          onClick={() => setState({ collapseDetails: !collapseDetails })}
        >
          {collapseDetails ? 'Show' : 'Hide'}
          <Icon
            type={collapseDetails ? 'double-right' : 'double-left'}
            style={{ transform: 'rotate(90deg)', fontSize: '14px' }}
          />
        </div>
      </div>
    );
  }
 
const lineColor = status === 'REACHED_DESTINATION_PORT'  ?  '#12bbbd' :'#0088ff';
  const renderMap = () => {
    return (
      <GoogleMap
        zoom={zoom || 3}
        ref={handleMapRef}
        defaultCenter={{lat:center.lat, lng: center.lng}}
        options={{
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
          keyboardShortcuts: false,
          zoomControl: false,
          scrollwheel: false,
          styles: VTMapRouteStyle,
          gestureHandling: 'greedy',
        }}
      >
        {getMarkers()}

        <Polyline
          path={originToCurrentLocation}
          options={{
            strokeColor: lineColor,
            strokeOpacity: 1,
            strokeWeight: 2,
          }}
        />

        <Polyline
          path={currentLocationToDestination}
          options={{
            strokeColor: lineColor,
            strokeOpacity: 0,
            icons: [
              {
                icon: {
                  path: 'M 0,-1 0,1',
                  strokeOpacity: 1,
                  scale: 3,
                },
                offset: '0',
                repeat: '25px',
              },
            ],
          }}
        />
      </GoogleMap>
    )
  }

  return (
    <div style={{ zIndex: 100 }}>
      {isZoomed ? renderZoomedInButton() : renderZoomedOutButton()}
      {isZoomed && renderContainerTrackingList()}
      {renderMap()}
    </div>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {};
};

export default withScriptjs(withGoogleMap(connect(mapStateToProps)(withStyles(styles)(MapVesselRoute))));
